export const filterCryptoAssets = (data) => {
  return (Array.isArray(data) ? data : [])
    .filter((item) => item.assets_types === "Crypto" && item.portfolio_allocation >= 0)
    .sort((a, b) => b.portfolio_allocation - a.portfolio_allocation);
};

export const extractPortfolioLabels = (data) => {
  return (Array.isArray(data) ? data : []).map((item) => item.symbol);
};

export const extractPortfolioAssetValues = (data) => {
  return (Array.isArray(data) ? data : []).map((item) =>
    parseFloat(item.assets_value).toFixed(2)
  );
};

export const extractPortfolioAlloctations = (data) => {
  return (Array.isArray(data) ? data : []).map((item) =>
    parseFloat(item.portfolio_allocation).toFixed(4)
  );
};

export const getTotalAssetsValue = (data) => {
  return (Array.isArray(data) ? data : [])
    .reduce((acc, item) => acc + parseFloat(item.assets_value), 0)
    .toFixed(3);
};

export const reformatPortfolioTrackRecordRoundFourDigit = (data) => {
  if (!data) {
    return null;
  }
  return {
    totalValue: parseFloat(data.total_assets_value).toFixed(4) * 1,
    impliedApr: (parseFloat(data.portfolio_implied_apr) * 100).toFixed(4) * 1,
    expectedApy: (parseFloat(data.portfolio_expected_apr) * 100).toFixed(4) * 1,
    thirtyDayEarning: parseFloat(data.portfolio_implied_30days_earnings).toFixed(4) * 1,
    expectedthirtyDayEarning:
      parseFloat(data.portfolio_expected_30days_earnings).toFixed(4) * 1,
    moneyAtRisk: parseFloat(data.money_at_risk_percent).toFixed(4) * 1,
    nev: parseFloat(data.net_exposure_value).toFixed(4) * 1,
    thirtyDayApy: (parseFloat(data.thirty_day_apy) * 100).toFixed(4) * 1,
    ninetyDayApy: (parseFloat(data.ninety_day_apy) * 100).toFixed(4) * 1,
    usdiInCirculation: parseFloat(data.usdi_in_circulation).toFixed(2) * 1,
    dollar_value_growth: parseFloat(data.dollar_value_growth).toFixed(4) * 1,
  };
};
